import { createSelector } from 'reselect';
import { getLoggedInUser } from 'src/modules/login/selectors/getLoggedInUser';
import { getProjectListData } from 'src/modules/project-list/selectors/getProjectListData';
import { applyProjectListQuery } from 'src/modules/project-list/utils/slice';

export const getProjectListSlice = createSelector([
  getProjectListData,
  getLoggedInUser,
], applyProjectListQuery);
